export { default as AttachDocumentDialogComponent } from './attach-document-dialog.component';